<template>
    <div class="previous-csv-button">
        <!--pc-->
        <vue-json-to-csv :json-data="csvList" :csv-title="csvFileName" class="pc-button">
            <el-button type="primary" @click="download" :disabled="isDisable">CSV出力</el-button>
        </vue-json-to-csv>
        <!--sp-->
        <div class="sp-button">
            <el-button type="primary" @click="downloadSp" :disabled="isDisableSp">ダウンロード(.CSV)</el-button>
        </div>
    </div>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
import module from '@/components/previous_data/utils/CsvDownload.js'

export default {
    props: {
        streamData: {
            type: Array,
            default: () => [],
            required: false
        },
        activeButton: {
            type: Boolean,
            defualt: false,
            required: false
        }
    },
    mixins: [module],
    components: {
        VueJsonToCsv
    },
    data() {
        return {
            csvList: [],
            rowData: {},
            time: 0,
            date: ''
        }
    },
    methods: {
        download: function() {
            this.csvList = []
            this.getCsvData()
        },
        
        downloadSp: async function() {
            this.csvList = []
            await this.$store.dispatch('getPreviousData')
            this.getCsvData()
            this.jsonToCsv()
        },
        
        getCsvData: async function() {
            this.streamData.forEach(stream => {
                stream.data_list.forEach(dailyData => {
                    dailyData.forEach((hourData, index) => {
                        if (index == 0) {
                            this.date = hourData.max
                        } else if (index !== 1) {
                            this.time = index - 2
                            this.$set(this.rowData, "日付", this.date)
                            this.$set(this.rowData, "カメラ名", stream.camera_name)
                            this.$set(this.rowData, "時間(24h)", this.time)
                            this.$set(this.rowData, "最大人数(人)", hourData.max)
                            this.$set(this.rowData, "最小人数(人)", hourData.min)
                            this.$set(this.rowData, "密集度(％)", hourData.density)
                            this.$set(this.rowData, "密集度レベル", hourData.density_level)
                            this.$set(this.rowData, "設定人数", stream.threshold)
                            this.csvList.push(JSON.parse(JSON.stringify(this.rowData)))
                        }
                    })
                })
            });
        },

        jsonToCsv: async function() {

            let labels = Object.getOwnPropertyNames({ ...this.csvList[0] })
            let labelsConf = this.$_createCsvLabelsConf(labels)
            let csvLabels = this.$_createCsvLabels(labelsConf, ',')
            let csvData = this.$_createCsvContent(this.csvList, labelsConf, ',')
            let content = csvLabels + csvData
            this.$_downloadCsv(`csv-${this._uid}`, content, this.csvFileName)
        }

        
    },
    computed: {
        csvFileName: {
            get() {
                const today = new Date();
                let year = String(today.getFullYear())
                let month = today.getMonth() + 1
                // 0パディング
                if (month < 10) {
                   month = "0" + String(month) 
                }
                let date = today.getDate()
                if (date < 10) {
                    date = "0" + String(date)
                }
                let fileName = year + month + date + "_report"
                
                return fileName
            }
        },
        isDisable() {
            if (this.streamData.length) {
                return false
            }
            return true
        },
        isDisableSp() {
            if (this.activeButton) {
                return false
            }
            return true
        }
    }
}
</script>

<style scoped>
    
    .previous-csv-button{
        display: inline;
    }
    
    .sp-button{
        display: none;
    }
    
    @media screen and (max-width: 980px) {
        .el-button{
            text-align: right;
        }
        
        .pc-button{
            display: none;
        }
        
        .sp-button{
            text-align: center;
            display: block;
            padding: 15px;
        }
    }
</style>